import StatusCircle from "../Status/StatusCircle";
import styles from "./TabNavItem.module.scss";

const TabNavItem = (props: NavItemProps) => {
  const handleClick = () => {
    props.setActiveTab(props.id);
  };

  return (
    <li
      onClick={handleClick}
      className={props.activeTab === props.id ? `${styles.active}` : ""}
    >
      {props.hasStatusCircle ? (
        <div className={styles.navitem}>
          <StatusCircle color={"success"} />

          <div className={styles.navitemtext}>
            {props.title}
          </div>
        </div>
      ) : (
        <div className={styles.navitemtext}>
          {props.title}
        </div>
      )}
    </li>
  );
};
export default TabNavItem;

interface NavItemProps {
  id: string;
  title: string;
  activeTab: string;
  setActiveTab: (param: any) => void;
  hasStatusCircle: boolean;
}
